import { QueryClient } from '@tanstack/react-query';

// Single app-wide QueryClient, created before the router so route guards can
// share cached data (e.g. the profile) with components instead of issuing
// their own raw axios fetches on every navigation.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 5_000,
    },
  },
});
